import {connect, useSelector} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../config/formatter";
import * as commonUtil from "../../../../config/common";
import * as o2Api from "../../../../api/api";
import "src/scss/grid-styles.scss";
import "src/scss/file.css";
import {Loading} from "../../../../components/common";
import * as XLSX from 'xlsx';
import StoreCornerListWhere from "../../where/StoreCornerListWhere";



const compareSaleTR = (props) => {

    const currentGridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [currentSaleData, setCurrentSaleData] = useState([]);
    const [uploadFile, setFile] = useState([]);

    const [pos, setPos] = useState([{deviceId: "전체"}]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        deviceId: "전체",
        saleDt: dayjs()
    });
    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };




    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            getStoreDevice();
        }
    }, [props.selected.storeCd]);

    const getStoreDevice = () => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn: "Y"
        };
        setLoading(true);
        o2Api.getStoreDevice(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                setPos([{deviceId: "전체"}]);
                setPos((state) => state.concat(responseBody));

                setLoading(false);
            }
        });
    };


    const [currentColumnDefs] = useState([
        {field: "no", headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1"},
        {
            headerName: "POS 매출", align : 'center',  cellClass: "static-cell", children: [
                {field: "posCd", headerName: "포스\n번호", minWidth: 60, cellClass: "static-cell"},
                {
                    field: "billNo",
                    headerName: "영수증\n번호",
                    minWidth: 80,
                    //cellClass: "static-cell",
                    cellStyle: {color: "blue", cursor: "pointer"}
                    , cellClass: "stringType"
                    , dataType:'String'
                },
                {field: "erestBillNo", headerName: "E-휴게소\n영수증번호", minWidth: 90, cellClass: "static-cell"},

                {
                    field: "tradeTypeNm",
                    headerName: "구분",
                    minWidth: 60,
                    cellClass: "static-cell",
                    cellStyle: {color: "blue", cursor: "pointer"}
                },
                {
                    field: "saleAmt",
                    headerName: "총매출액",
                    minWidth: 80,
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                }
            ]
        },
        {
            headerName: "도로공사 매출(엑셀)", align : 'center', cellClass: "static-cell", children: [
                 {field: "excelErestBillNo", headerName: "엑셀-도로공사\n영수증번호",  minWidth: 90, cellClass: "static-cell" , dataType:'String' }
                ,{field: "excelSaleAmt", headerName: "엑셀-도로공사\n총매출액", minWidth: 90, cellClass: "static-cell"}
            ]
        }

        /* 일치/불일치 여부 확인필드*/
        ,{field: "equalCheck", headerName: "비고", minWidth: 90, cellClass: "static-cell"}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    const search = () => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
            saleDt: searchForm.saleDt.format("YYYYMMDD")
        };

        /*if(params.posCd === ""){
            alert("POS번호를 선택해 주세요.");
            return false;
        }*/

        setLoading(false);
        setFile("");

        o2Api.getCurrentDay(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log("result : ", responseBody);

                setLoading(false);
                setCurrentSaleData(responseBody);

                //createCurrentTotalRowData(responseBody);
            }
        });
    };

    const readExcel=(file)=>{

        const gridRows = currentSaleData.length;
        if(gridRows == 0){
            alert("매출 자료를 먼저 조회 해주세요.");
            return false;
        }

        //console.log("file.name :: ", file.name);
        setFile(file.name);

        const { api } = currentGridRef.current;
        if (api === null) return;

        const promise = new Promise((resolve,reject)=>{
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);
            fileReader.onload=(e)=>{
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, {type: 'buffer'});
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws); //엑셀데이터 Json 추출 완료

                resolve(data);
            };

            fileReader.onerror=(error)=>{
                reject(error);
            };
        });//end promise

        promise.then((result)=>{

            //console.log("엑셀 업로드 값들::", result);
            //console.log("조회 그리드 값들 ::", currentSaleData);

            currentSaleData.some((saleData) => { //그리드 data 반복
                result.some( (excelData) => { //엑셀 data 반복
                    if(saleData.erestBillNo === excelData[Object.keys(excelData)[0]]){
                        saleData.excelErestBillNo = excelData[Object.keys(excelData)[0]];
                        saleData.excelSaleAmt = excelData[Object.keys(excelData)[1]];
                        saleData.equalCheck = "일치";
                    }else{
                        saleData.equalCheck = "불일치";
                    }
                    //영수증 일치할 경우, 해당 건 비교 중지
                    return (saleData.erestBillNo === excelData[Object.keys(excelData)[0]]);
                }); //end Excel
            }); //end 그리드

            api.refreshCells();  // ==> 영수증 데이터 비교 완료 후, 그리드 refresh 적용

        }); //end promise.then
    }; //end readExcel()


 /*#####여기부터 화면 영역#####*/
    return (
    <>
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>도로공사 매출 대사</h5>
                <CButton color="dark" onClick={search}>조회</CButton>
            </div>

            <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
                <CCol xs={12}>
                    <CInputGroup size={"sm"}>
                        <CInputGroupText style={{width: 100}}>조회일자</CInputGroupText>
                        <CInputGroupText style={{background: "white", height: 35}}>
                            <DatePicker bordered={false}
                                        separator={"~"}
                                        placeholder={""}
                                        locale={locale}
                                        value={searchForm.saleDt}
                                        onChange={(dayjs, dateString) => {
                                            setSearchForm((state) => ({
                                                ...state, saleDt: dayjs
                                            }));
                                        }}/>
                        </CInputGroupText>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup size={"sm"}>
                        <CInputGroupText style={{width: 100}}>포스번호</CInputGroupText>
                        <CFormSelect value={searchForm.deviceId}
                                     onChange={(e) => {
                                         setSearchForm((state) => ({
                                             ...state,
                                             deviceId: e.target.value
                                         }));
                                     }}
                        >
                            {pos.map((p, index) => {
                                return (
                                    <option key={index} value={p.deviceId}>{p.deviceId}</option>
                                );
                            })}
                        </CFormSelect>
                    </CInputGroup>
                </CCol>
            </CForm>
            {/* End 조회조건 영역*/}

            {/*Start 그리드 영역*/}
            <div style={{height: 10}}/>
            <div>
               <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                   {/*<span>[POS 매출 VS 도로공사 매출전송] 자료 대사</span>*/}
                   <span style={{width: 100, height: 500, marginTop: 10}}></span>
                   <span className="filebox"  >
                       <label htmlFor="file">엑셀 업로드</label>
                       <input type="file" id="file" onChange={(e)=>{
                           const file = e.target.files[0];
                           readExcel(file);
                           e.target.value = '';
                       }}/>

                       <input  className="upload-name" name="fileName" value={uploadFile}  />
                   </span>
                </div>


                <div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                    <AgGridReact
                        ref={currentGridRef}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={currentSaleData}
                        localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                        animateRows={true}
                        //pinnedBottomRowData={statTotalRowData}
                        defaultColDef={defaultColDef}
                        columnDefs={currentColumnDefs}>
                    </AgGridReact>
                </div>
            </div>

        </div>
    </>
    ); //end return

}; //end compareSaleTR

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(compareSaleTR);
